
<div class="ifc-model-viewer--container">
    <div class="ifc-model-viewer--toolbar-container"></div>
    <canvas class="ifc-model-viewer--model-canvas"></canvas>
</div>

<canvas class="ifc-model-viewer--nav-cube-canvas"></canvas>
